module.exports = __webpack_public_path__ + "media/images/social-share-button/xing-dc9a2b2304a9d39eea11a4dcb406109e.svg";